/* eslint-disable prettier/prettier */
/* eslint-disable object-curly-spacing */
/* eslint-disable arrow-body-style */
import { Authorisation } from "@iventis/domain-model/model/authorisation";
import { Permission } from "@iventis/domain-model/model/permission";
import { media, styled, truncateText } from "@iventis/styles";
import { Content } from "@iventis/translations/content/typed-content";
import { Button } from "@mui/material";
import { Theme } from "@emotion/react";
import React from "react";

import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { UserThumbnail } from "@iventis/components";
import { PermissionResourceType } from "@iventis/domain-model/model/permissionResourceType";
import { AuthorisationSelector } from "./authorisation-selector";

export const PermissionEntry: React.FC<{
    permission: Permission;
    removeable: boolean;
    resourceType: PermissionResourceType;
    disabled?: boolean;
    selectorOpen?: boolean;
    remove?: (permission: Permission) => void;
    change: (permission: Permission, authorisation: Authorisation) => void;
}> = ({ permission, removeable, remove, change, disabled, selectorOpen, resourceType }) => {
    const translate = useIventisTranslate();

    return (
        <StyledContainer>
            <EntryLabel>
                <StyledUserThumbnail />
                <StyledSpan className={truncateText}>{permission.ownerName}</StyledSpan>
            </EntryLabel>
            <Inputs>
                {removeable && (
                    <Button className="remove-button" style={{ flexGrow: 1 }} disabled={disabled} onClick={() => remove(permission)}>
                        {translate(Content.common.buttons.remove)}
                    </Button>
                )}
                <StyledAuthorisationSelector
                    disabled={disabled}
                    open={selectorOpen}
                    authLevel={permission.authorisation}
                    onChange={(authorisation) => change(permission, authorisation)}
                    dataTestId={`permission-entry-selector-${permission.ownerName}`}
                    resourceType={resourceType}
                />
            </Inputs>
        </StyledContainer>
    );
};

const StyledContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    width: auto;
    background-color: ${(props) => props.theme.secondaryColors.light20};
    min-height: 50px;
    padding-left: 20px;
    padding-right: 20px;

    .remove-button {
        color: ${({ theme }: { theme: Theme }) => theme.typographyColors.subdued};
        margin-right: 2rem;
    }

    ${media.extraSmall} {
        display: block;
    }

    .MuiInputBase-input {
        height: fit-content;
    }
`;

const EntryLabel = styled.div`
    display: flex;
    align-items: center;
    word-break: break-all;

    ${media.extraSmall} {
        padding-top: 20px;
        padding-bottom: 10px;
    }
`;

const StyledSpan = styled.span`
    max-width: 330px;
`;

const Inputs = styled.div`
    display: flex;
    align-items: center;

    ${media.extraSmall} {
        padding-top: 10px;
        padding-bottom: 20px;
        justify-content: stretch;
    }
`;

const StyledUserThumbnail: React.FC = styled(UserThumbnail)`
    width: 20px;
    height: 20px;
    margin-right: 10px;
`;

const StyledAuthorisationSelector = styled(AuthorisationSelector)`
    min-width: 100px;
    flex-grow: 1;
`;
